import { capitalizeOnlyFirstLetter } from './capitalize-only-first-letter';

export function snakeCaseToSentenceCase(snakeStr: string): string {
  // Replace underscores with spaces
  const result = snakeStr.replace(/_+/g, ' ').trim();

  // Capitalize the first letter
  return capitalizeOnlyFirstLetter(result);
}
